type RenderAlphabetProps = {
  shift: number;
  setShift: React.Dispatch<React.SetStateAction<number>>;
  blockUserInput: boolean;
  type: string;
};
const RenderAlphabet: React.FC<RenderAlphabetProps> = ({
  shift,
  setShift,
  blockUserInput,
  type,
}) => {
  const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";
  const alphabetType2 = "#%&+Ђ=>?@£¤¥Ä»«ÆÞ<ÐЉ∑∞≠≈◊∫∅ẀÎĘŃ‡√"

  const numberArray = Array.from({ length: alphabet.length }, (_, i) => i + 1);
  const handleLeft = () => {
    if (blockUserInput) return;

    setShift((prev) => (prev - 1 + numberArray.length) % numberArray.length);
  };

  const handleRight = () => {
    if (blockUserInput) return;

    setShift((prev) => (prev + 1) % numberArray.length);
  };

  const shiftedNumbers = numberArray.map(
    (_, index) =>
      numberArray[(index - shift + numberArray.length) % numberArray.length],
  );

  return (
    <div className="CaesarСipher-alphabet-wrapper">
      {type === "1" && (
        <img
          className={`CaesarСipher-icon ${
            blockUserInput ? "CaesarСipher-icon--disabled" : ""
          }`}
          id="CaesarСipher-alphabet-icon"
          alt="Влево"
          src="/img/caesarcipher/left.svg"
          title="Влево"
          onClick={handleLeft}
        />
      )}

      <div className="CaesarСipher-alphabet">
        <div className="CaesarСipher-rows">
          {(type==="1"?shiftedNumbers:alphabetType2.split("")).map((number, index) => (
            <div key={index} className="CaesarСipher-alphabet-item">
              <span className="CaesarСipher-alphabet-number">{number}</span>
            </div>
          ))}
        </div>

        <div className="CaesarСipher-rows">
          {alphabet.split("").map((letter, index) => (
            <div key={index} className="CaesarСipher-alphabet-item">
              <span className="CaesarСipher-alphabet-letter">{letter}</span>
            </div>
          ))}
        </div>
      </div>

      {type === "1" && (
        <img
          className={`CaesarСipher-icon ${
            blockUserInput ? "CaesarСipher-icon--disabled" : ""
          }`}
          id="CaesarСipher-alphabet-icon"
          alt="Вправо"
          src="/img/caesarcipher/right.svg"
          title="Вправо"
          onClick={handleRight}
        />
      )}
    </div>
  );
};

export default RenderAlphabet;
